import React from 'react'


const Image = (props) =>
    <svg
        {...props}
        viewBox="0 0 31.813 26"
        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
        <path d="M29.835 26H2.008a1.995 1.995 0 0 1-1.987-2V2c0-1.103.891-2 1.987-2h27.827c1.096 0 1.987.897 1.987 2v22c0 1.103-.891 2-1.987 2zm.103-24h-28v13.835l7.36-6.582a.989.989 0 0 1 1.363.04l7.322 7.367 4.274-3.441a.987.987 0 0 1 1.324.074l6.357 6.397V2zm0 20.518l-7.134-7.178-4.274 3.441a.99.99 0 0 1-1.324-.074l-7.288-7.333-7.98 7.138V24h28v-1.482zM20.89 8.002c0-1.104.893-2.002 1.99-2.002 1.095 0 1.986.898 1.986 2.002A1.994 1.994 0 0 1 22.88 10a1.996 1.996 0 0 1-1.99-1.998zm1.987-.001L22.88 9V8l-.003.001z"
              fillRule="evenodd"/>
    </svg>

export default Image


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Image.js